<template>
	<footer class="page-footer">
		<div class="footer-container">
			<h3
				id="about-platform"
				class="section-title"
			>
				О платформе
			</h3>
			<div class="footer-content">
				<div class="company-info">
					<h4>ООО «СИБВАЛЕО ФОРИН ТРЭЙД»</h4>
					<div class="legal-details">
						<p><span>ИНН</span>5402540887</p>
						<p><span>ОГРН</span>1115476088408</p>
						<p><span>Юр. адрес</span>630004, г. Новосибирск, ул. Ленина, 48, этаж 3, помещение 29.</p>
					</div>
				</div>

				<div class="footer-links">
					<a
						href="mailto:info@got.market"
						class="email"
					>info@got.market</a>
					<router-link to="/contracts/userConfidential">Политика в отношении обработки персональных данных</router-link>
					<router-link to="/contracts/userAgreement">Пользовательское соглашение</router-link>
				</div>
			</div>

			<div class="footer-bottom">
				<p class="slogan">
					GOT.MARKET помогает найти необходимое сырьё для вашего бизнеса!
				</p>
				<p class="copyright">
					© {{ currentYear }} ООО «СИБВАЛЕО ФОРИН ТРЭЙД»
				</p>
			</div>
		</div>
	</footer>
</template>

<style scoped lang="scss" src="./MainFooter.scss"/>

<script lang="ts">
export default defineComponent({
	name: 'MainFooter',

	computed: {
		currentYear() {
			return new Date().getFullYear();
		},
	},
});
</script>

